import type { GetBankAccountsDirectoryParams } from '../types/bankAccountsDirectoryTypes'

export const bankAccountsDirectoryKeys = {
  all: ['treasury', 'bankAccountsDirectory'] as const,

  lists: () => [...bankAccountsDirectoryKeys.all, 'list'] as const,
  list: (filters: GetBankAccountsDirectoryParams) =>
    [...bankAccountsDirectoryKeys.lists(), filters] as const,
}
